export const SET_OPTED_IN = "SET_OPTED_IN";
export const SET_ITEM_COUNT = "SET_ITEM_COUNT";
export const SET_ENABLE_COMPLIANCE_VARIANT = "SET_ENABLE_COMPLIANCE_VARIANT";
export const SET_LOYALTY_STATUS = "SET_LOYALTY_STATUS";
